import Lock from '@/libs/wallet_connectors/lock';
import Injected from '@/libs/wallet_connectors/connectors/injected';
import Fortmatic from '@/libs/wallet_connectors/connectors/fortmatic';
import Walletconnect from '@/libs/wallet_connectors/connectors/walletconnect';
import BSC from '@/libs/wallet_connectors/connectors/bsc';
import Onto from '@/libs/wallet_connectors/connectors/onto';
import Walletlink from '@/libs/wallet_connectors/connectors/walletlink';
import config from '@/config';
import { Contract as BscContract } from '@ethersproject/contracts';
import provider from '@/helpers/provider';
import BigNumber from 'bignumber.js';
import Web3 from 'web3';
import { MaxUint256 } from '@ethersproject/constants';

import abi from '../../abi';

const prefixKey = `${process.env.VUE_APP_NETWORK}-${process.env.VUE_APP_ENV}`;
let suffix;
if (process.env.VUE_APP_VERSION_DEPLOY) {
  suffix = process.env.VUE_APP_VERSION_DEPLOY;
}

const PREFERENCES = `${prefixKey}-buni-preferences-display-info-${suffix}`;

export const lock = new Lock();

const connectors: any = {
  injected: Injected,
  metamask: Injected,
  trustwallet: Injected,
  mathwallet: Injected,
  tokenpocket: Injected,
  safepalwallet: Injected,
  fortmatic: Fortmatic,
  walletconnect: Walletconnect,
  walletlink: Walletlink,
  bsc: BSC,
  ontowallet: Onto,
  coin98: Injected
};

for (const connectorId in connectors) {
  const connector: any = {
    key: connectorId,
    connector: connectors[connectorId],
    options: config.configWallet.connectors[connectorId]
  };
  lock.addConnector(connector);
}

export function getConnectorName(connectorId: any) {
  if (connectorId === 'injected') {
    const provider = window.ethereum || {};
    // @ts-ignore
    if (provider.isMetaMask) {
      return 'MetaMask';
    }
    // @ts-ignore
    if (provider.isImToken) {
      return 'imToken';
    }
    // @ts-ignore
    if (provider.isStatus) {
      return 'Status';
    }
    // @ts-ignore
    if (provider.isTrust) {
      return 'Trust Wallet';
    }
    // @ts-ignore
    if (provider.isFrame) {
      return 'Frame';
    }
    // @ts-ignore
    if (provider.isCoin98) {
      return 'Coin98 Wallet';
    }
    return 'Browser Wallet';
  }
  if (connectorId === 'fortmatic') {
    return 'Fortmatic';
  }
  if (connectorId === 'walletconnect') {
    return 'WalletConnect';
  }
  if (connectorId === 'walletlink') {
    return 'Coinbase Wallet';
  }

  if (connectorId === 'metamask') {
    return 'MetaMask';
  }

  if (connectorId === 'mathwallet') {
    return 'MathWallet';
  }

  if (connectorId === 'ontowallet') {
    return 'ONTO Wallet';
  }

  if (connectorId === 'coin98') {
    return 'Coin98 Wallet';
  }
  return 'Unknown';
}

function getPreferences() {
  const defaultPreferences = {
    connectorId: null,
    auth: {
      token: null,
      address: null
    },
    referralId: null
  };
  const preferenceString = localStorage.getItem(PREFERENCES);
  const preferences = JSON.parse(preferenceString || '{}');
  return {
    ...defaultPreferences,
    ...preferences
  };
}

export default class Storage {
  static getConnectorId() {
    const preferences = getPreferences();
    return preferences.connectorId;
  }

  static getReferralId() {
    const preferences = getPreferences();
    return preferences.referralId;
  }

  static saveConnectorId(connectorId: any) {
    const preferences = getPreferences();

    preferences.connectorId = connectorId;
    localStorage.setItem(PREFERENCES, JSON.stringify(preferences));
  }

  static saveReferralId(referralId: any) {
    const preferences = getPreferences();

    preferences.referralId = referralId;
    localStorage.setItem(PREFERENCES, JSON.stringify(preferences));
  }

  static removeWalletLinkInfo() {
    localStorage.removeItem(
      '-walletlink:https://www.walletlink.org:session:id'
    );
    localStorage.removeItem(
      '-walletlink:https://www.walletlink.org:session:secret'
    );
    localStorage.removeItem(
      '-walletlink:https://www.walletlink.org:session:linked'
    );
    localStorage.removeItem('-walletlink:https://www.walletlink.org:Addresses');
  }

  static removeWalletConnect() {
    localStorage.removeItem('walletconnect');
  }

  static saveToken(token: any, address: any) {
    const preferences = getPreferences();
    preferences.auth = {
      token,
      address
    };
    localStorage.setItem(PREFERENCES, JSON.stringify(preferences));
  }

  static removeAuth() {
    const preferences = getPreferences();
    preferences.auth = null;
    localStorage.setItem(PREFERENCES, JSON.stringify(preferences));
  }
  static removeAccessToken() {
    const preferences = getPreferences();
    if (preferences.auth && preferences.auth.token) {
      preferences.auth.token = null;
    }
    localStorage.setItem(PREFERENCES, JSON.stringify(preferences));
  }
  static getToken() {
    const auth = Storage.getAuth();
    if (auth) {
      return auth.token;
    }
    return null;
  }

  static getAuth() {
    const preferences = getPreferences();
    return preferences.auth;
  }
}
export const sliceAddress = (address: any, numberSlice: any) =>
  address.slice(0, numberSlice) +
  '...' +
  address.slice(address.length - numberSlice, address.length);

export async function fetchUserBalance(contractAddress: any, userAddress: any) {
  const contract = await new BscContract(
    contractAddress,
    abi['ERC20'],
    provider
  );

  const userBalance = await contract.balanceOf(userAddress);
  return userBalance.toString();
}

export async function estimateGas(contract: any, action: any, params: any) {
  let gasLimitNumber = 400000;
  try {
    const rawValue = await contract.estimateGas[action](...params);
    gasLimitNumber = rawValue.toNumber();
  } catch (_e) {
    const e: any = _e;
    console.error('estimateGas ERROR:', e.message);
  }

  return (
    '' +
    new BigNumber(gasLimitNumber)
      .times(1.4)
      .integerValue()
      .toFixed(BigNumber.ROUND_UP)
  );
}

export async function handleApprove(
  contract: any,
  tokenContract: any,
  from: any,
  feeIn: any
) {
  const allowance = await tokenContract.allowance(from, contract.address);
  if (new BigNumber(feeIn).lte(allowance.toString())) {
    return null;
  }

  try {
    const approveRes = await new BscContract(
      tokenContract.address,
      abi['ERC20-HERA'],
      provider.getSigner()
    ).approve(contract.address, MaxUint256.toString());
    await provider.waitForTransaction(approveRes.hash, 2);
  } catch (_e) {
    const e: any = _e;
    console.error('handleApprove error:', e);
    console.error(
      'handleApprove error code:',
      e.code,
      feeIn.toString(),
      tokenContract.address,
      MaxUint256.toString()
    );
    if (e.code && e.code === 4001) {
      throw e;
    }
    const approveRes = await new BscContract(
      tokenContract.address,
      abi['ERC20-HERA'],
      provider.getSigner()
    ).approve(contract.address, feeIn.toString());
    await provider.waitForTransaction(approveRes.hash, 2);
  }
}

export function convertWeiToDec(wei: any, decimalPlaces = 4) {
  if (wei === undefined) {
    wei = '';
  }
  return new BigNumber(
    new BigNumber(Web3.utils.fromWei(wei.toString(), 'ether'))
  ).toFixed(decimalPlaces);
}
export const cleanObject = (obj: any) => {
  const newObject: any = {};
  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      newObject[key] = obj[key];
    }
  }
  return newObject;
};
export function convertDecToWei(amount: any) {
  return new BigNumber(amount.toString()).multipliedBy(1e18).toString();
}
export async function sleep(ms: any) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
export function isTxRejected(error: any) {
  if (!error) {
    return false;
  }
  return error.code === 4001;
}
export function handleTransactionError(
  transactionError: any,
  useOffChain = false
) {
  let messages = 'Oops, something went wrong. Please reload page';
  if (isTxRejected(transactionError)) {
    messages = "You've rejected this transaction";
    if (useOffChain) {
      messages =
        'You have rejected this transaction. Check your transactions in Pending';
    }
  } else {
    console.error('transactionError', transactionError);
  }

  return messages;
}
export function getSellMethod(sellMethodCode: any) {
  switch (sellMethodCode) {
    case 'dutch_auction':
      return 'Dutch Auction';
    case 'auction':
      return 'Auction';
    case 'fixed_price':
      return 'Fixed Price';
    default:
      return '';
  }
}

// export const getTaxPrice = (nftContract) => {
//   const { minPrice, tax = 10 } = nftContract;
//   const priceTax =  minPrice * tax / 100;
//   return priceTax;
// }

// eslint-disable-next-line no-unused-vars
export function getNftTax(nftContract: any) {
  return 0.1;
}
